import React from 'react';
import styles from './ErrorFallback.module.css';
import internalError from '../../images/internal_error.png';
function ErrorFallback({ error }) {
  return (
    <div className={styles.main}>
      <div className={styles.content}>
        <span className={styles.title}>Looks like something has gone wrong..</span>
        <strong>Please refresh the page If issue persist,</strong>
        <br />
        <span style={{ textAlign: 'right' }}>
        Please contact to the local IT team.
        </span>
      </div>
      <img src={internalError} alt="internal-error" />
    </div>
  );
}

export default ErrorFallback;
